import "./index.scss";

interface IProps {
  onClick?: () => void;
}

export const DeleteIcon = ({ onClick }: IProps) => {
  return (
    <div className="delete-icon-container" onClick={onClick}>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.5"
          y="1.48047"
          width="31"
          height="30"
          rx="4.5"
          stroke="#DC3545"
        />
        <path
          d="M10.8571 22.3138C10.8571 23.2305 11.6286 23.9805 12.5714 23.9805H19.4286C20.3714 23.9805 21.1429 23.2305 21.1429 22.3138V12.3138H10.8571V22.3138ZM22 9.8138H19L18.1429 8.98047H13.8571L13 9.8138H10V11.4805H22V9.8138Z"
          fill="#DC3545"
        />
      </svg>
    </div>
  );
};
